import { PlayerService } from '../../service/player.service';
import { Component, OnInit } from '@angular/core';

import { FindPage } from '../find/find';
import { ProfilePage } from '../profile/profile';
import { HomePage } from '../home/home';
import { PlayerPage } from '../player/player';
import { NavController } from 'ionic-angular';

@Component({
  templateUrl: 'tabs.html'
})
export class TabsPage implements OnInit {

  tab1Root = HomePage;
  tab2Root = FindPage;
  tab3Root = ProfilePage;

  constructor(public navCtrl: NavController, public playerService: PlayerService) {
  }

  ngOnInit() {

    this.playerService.load(1, false);

  }

  ShowPlayer() {
    this.navCtrl.push(PlayerPage);
  }

}



// WEBPACK FOOTER //
// ./src/pages/tabs/tabs.ts